export default __webpack_public_path__ + "static/media/edna.4f89771f.png";